import { useState, useEffect } from "react";
import ContentLoader from 'react-content-loader';

import { DocumentActions } from '../../static/js/app/document/reflux/document_store';

import './styles.scss';

const ContainerIframeAI = ({ summaryAI, onClose }) => {
    const [isLoaded, setIsLoaded] = useState(false);
    const [timestamp, setTimestamp] = useState("");

    useEffect(() => {
        window.addEventListener("message", listenerPostMessage);

        const now = new Date().getTime().toString();
        setTimestamp(now);

        return () => {
            window.removeEventListener("message", listenerPostMessage);
        };
    }, []);

    const listenerPostMessage = (e) => {
		const reveiveData = e.data;

		if (reveiveData.event === 'GET_SETUP') {
            DocumentActions.downloadFileAndSetupAI(summaryAI.fieldId, summaryAI.inputDocumentValue, () => {
                setIsLoaded(true);
            });
		}
		else if (reveiveData.event === 'SET_IS_OPEN_CHAT') {
			onClose();
		}
        else if (reveiveData.event === 'EXPAND') {
            const elementDrawer = document.querySelector("#drawer-root .drawer.drawer-right");

            if (elementDrawer && elementDrawer.style) {
                elementDrawer.style.width = !!reveiveData.isExpand ? "60%" : "40%";
            }
        }
	}

    return (
        <>
            {!isLoaded &&
                <div className='iframe-ai-web-loader'>
                    <div className="container-skeleton-header">
                        <ContentLoader
                            speed={0.5}
                            backgroundColor="#f1f1f1"
                            foregroundColor="#ebebeb"
                            className="container-skeleton"
                        >
                            <rect x="0" y="0" rx="8" ry="8" width="100%" height="30" />
                        </ContentLoader>
                    </div>
                    <div className="container-skeleton-body">
                        <ContentLoader
                            speed={0.5}
                            backgroundColor="#f1f1f1"
                            foregroundColor="#ebebeb"
                            className="container-skeleton"
                        >
                            <rect x="50" y="0" rx="12" ry="12" width="60%" height="90" />
                            <circle cx="20" cy="20" r="20" />

                            <rect x="50" y="110" rx="12" ry="12" width="50%" height="70" />
                            <circle cx="20" cy="130" r="20" />
                        </ContentLoader>
                    </div>
                    <div className="container-skeleton-footer">
                        <ContentLoader
                            speed={0.5}
                            backgroundColor="#f1f1f1"
                            foregroundColor="#ebebeb"
                            className="container-skeleton"
                        >
                            <rect x="0" y="0" rx="8" ry="8" width="100%" height="60" />
                        </ContentLoader>
                    </div>
                </div>
            }

            {timestamp &&
                <iframe id="iframe-ai-web" title='iframe-ai-web' src={`${window.location.origin}/ai-web/?timestamp=${timestamp}`} />
            }
        </>
    )
};

export { ContainerIframeAI };
